export enum AnalyticsType {
  YA_METRIKA = "ya_metrika",
  VK_PIXEL = "vk_pixel",
  GA_3 = "ga_3",
  OWN_ANALYTICS = "own_analytics",
  MAIL_RU = "mail_ru"
}